/* @flow */

import { type Poll } from '../utils/api';
import { type Etapa } from './types';
import { NOMES_ETAPAS } from './constants';

const pollParaEtapa = (poll: Poll): Etapa => ({
    entrada: poll.entrada,
    etapasId: poll.etapasId,
    nome: NOMES_ETAPAS[poll.etapasId],
    observacao: '',
});

export default pollParaEtapa;
